"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApplicationStaticAssetPath = void 0;
function getApplicationStaticAssetPath(assetPath, applicationName, env = 'production', productionPrefix = 'apps') {
    if (!assetPath) {
        throw new Error("You must provide at least the asset's name to get it's full path");
    }
    if (!applicationName) {
        throw new Error('Application name must be specified');
    }
    if (!env) {
        throw new Error('env must not be empty');
    }
    if (['staging', 'production'].includes(env)) {
        return [productionPrefix, applicationName, assetPath].join('/');
    }
    return assetPath;
}
exports.getApplicationStaticAssetPath = getApplicationStaticAssetPath;
